import React, { useState, useEffect, useRef } from 'react'
import TileIcon from '../../../assets/codicons/tile.svg'
import ListIcon from '../../../assets/codicons/list.svg'

const SORT_OPTIONS = [
  { key: 'rank', label: 'Most Popular' },
  { key: 'date', label: 'Newest' },
  { key: 'az', label: 'A → Z' }
]

const SortableList = ({ sortBy, onChange }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setMenuOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const currentLabel =
    SORT_OPTIONS.find((o) => o.key === sortBy)?.label ?? 'Sort'

  return (
    <div className='sortable-list' ref={ref}>
      <a
        className={menuOpen ? 'open' : ''}
        onClick={(e) => {
          e.preventDefault()
          setMenuOpen((prev) => !prev)
        }}
        href='#/'
      >
        <span className='sortable-label'>Sort by: </span>
        <span>{currentLabel}</span>
        <i className={`fa fa-angle-${menuOpen ? 'up' : 'down'}`} />
      </a>

      {menuOpen && (
        <div className='sortable-list-popup-menu'>
          <ul>
            {SORT_OPTIONS.map(({ key, label }) => (
              <li key={key}>
                <a
                  href='#/'
                  className={sortBy === key ? 'selected' : ''}
                  onClick={(e) => {
                    e.preventDefault()
                    onChange(key)
                    setMenuOpen(false)
                  }}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

const LayoutSelector = ({ layout, onChange }) => (
  <ul className='layout-selector'>
    <li
      className={layout === 'tile' ? 'active' : ''}
      onClick={() => onChange('tile')}
    >
      <TileIcon className='codicon' />
    </li>
    <li
      className={layout === 'list' ? 'active' : ''}
      onClick={() => onChange('list')}
    >
      <ListIcon className='codicon' />
    </li>
  </ul>
)

const BrowseOptions = ({
  sortBy,
  onSortChange = () => {},
  layout = 'tile',
  onLayoutChange = () => {}
}) => (
  <div className='browse-options'>
    <div className='sortable-list-container'>
      <SortableList sortBy={sortBy} onChange={onSortChange} />
    </div>
    <LayoutSelector layout={layout} onChange={onLayoutChange} />
  </div>
)

export default BrowseOptions
